import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import './diner-banner.css';

const hatImg = require('./chef-hat.png');
const cutleryImg = require('./cutlery.png');

const DinerBanner = (props) => {
  return (
    <div className="diner-banner-container">
      <h1 className="diner-banner-title">
        Welcome to Cuisine Crafters<sup>&#174;</sup>
      </h1>

      <div className="diner-banner-options-container" data-test-id={"findmeachef"}>
        <button onClick={props.chefClick}>
          <span>Find me a Chef</span>

          <img src={hatImg} />
        </button>

        <button onClick={props.dinerClick} data-test-id={"cravingadish"}>
          <span>I'm craving a Dish</span>
          <img src={cutleryImg} />
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {};

export default withRouter(connect(mapStateToProps)(DinerBanner));
